import { useEffect } from 'react';
import { toast } from 'sonner';
import { useSearch } from '../contexts/SearchContext';
import { useQueue } from '../contexts/QueueContext';
import {
  buildDiscoverySearchQuery,
  recordDiscoveryEvent,
  toRecommendationSeed,
} from '../lib/discoveryActions';
import { getAutoplayRecommendations } from '../services/recommendationService';

const DiscoveryActionBridge = () => {
  const { openSearch } = useSearch();
  const { playNext, queue, history } = useQueue();

  useEffect(() => {
    const handleDiscoveryAction = async (event) => {
      const action = event.detail || {};
      const media = action.media || {};

      recordDiscoveryEvent('discovery_action_selected', {
        action_id: action.id,
        action_kind: action.kind,
        media_id: media.id,
        media_title: media.title,
      });

      if (action.id === 'queue') {
        try {
          const seed = toRecommendationSeed(media);
          const recommendations = await getAutoplayRecommendations({
            seed,
            queue,
            history,
            limit: 1,
          });
          const recommendation = recommendations[0];
          if (!recommendation) {
            openSearch(buildDiscoverySearchQuery({ id: 'similar' }, media));
            toast.info('No direct match yet — opening similar music.');
            return;
          }
          playNext({
            ...recommendation,
            discovery_added: true,
            recommendation_reason: recommendation.reason,
            recommendation_source: recommendation.source,
          });
          recordDiscoveryEvent('discovery_queue_added', {
            media_id: media.id,
            recommended_id: recommendation.track_id,
          });
          toast.success(`${recommendation.title || 'A similar tune'} added next`);
        } catch (error) {
          recordDiscoveryEvent('discovery_queue_failed', {
            media_id: media.id,
            message: error?.message || 'Unknown recommendation error',
          });
          openSearch(buildDiscoverySearchQuery({ id: 'similar' }, media));
          toast.info('Opening similar music instead.');
        }
        return;
      }

      openSearch(buildDiscoverySearchQuery(action, media));
    };

    window.addEventListener('rastyle:discovery-action', handleDiscoveryAction);
    return () => window.removeEventListener('rastyle:discovery-action', handleDiscoveryAction);
  }, [history, openSearch, playNext, queue]);

  return null;
};

export default DiscoveryActionBridge;
